const BASE_URL = window.location.protocol + '//' + window.location.host
const HOME_URL = window.location.protocol + '//' + window.location.host

export { BASE_URL, HOME_URL }